export const BASE_URL = "https://openmind-api.vercel.app/5-4";
